import Immutable from 'immutable';
import _ from 'lodash';
import {
  SET_ACTIVE_COHORT,
  UPDATE_COHORTS,
  COHORT_ADD_ASSESSMENT_PRESET,
  COHORT_DELETE_ASSESSMENT_PRESET,
  UPDATE_COHORT_ASSESSMENT_SETTINGS,
  UPDATE_COHORT_ENROLMENT_CLOSE_DATE,
} from './actions';
import {
  UPDATE_COHORT_STARTDATE,
  UPDATE_COHORT_ENDDATE,
  SET_COHORT_SCHEDULED_MODE,
  SET_COHORT_OPEN_MODE,
  SET_COHORT_SELF_PACED_MODE,
  UPDATE_COHORT_SELF_PACED,
} from '../../web/containers/CohortAdmin/CohortTimeline/store';
import {
  COURSES_FETCH_SUCCESS,
  COURSES_LOAD_SUCCESS,
  COURSES_FREE_FETCH_SUCCESS,
  COURSES_FREE_LOAD_SUCCESS,
  COURSES_PAID_FETCH_SUCCESS,
  COURSES_PAID_LOAD_SUCCESS,
  COURSES_FEATURED_FETCH_SUCCESS,
  COURSES_FEATURED_LOAD_SUCCESS,
} from '../Courses/CoursesList/actions';
import { UPDATE_ENROLLED_CLASS_DATA, LOGOUT_SUCCESS } from '../Auth/actions';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
} from '../Notifications/actions';
import {
  SET_BLOCK_FEED_DATA,
  APPEND_BLOCK_FEED_DATA,
  PREPEND_BLOCK_FEED_DATA,
  FEED_DATA_FETCH_SUCCESS,
  FEED_DATA_REFRESH_SUCCESS,
  FEED_DATA_LOAD_MORE_SUCCESS,
  BLOCK_FEED_DATA_LOAD_MORE_SUCCESS,
} from '../Feeds/actions';
import {
  FETCH_ENROLLED_CLASS_DATA_SUCCESS,
  SET_COURSE_LANDING_PAGE_DATA,
} from '../Courses/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { FETCH_COURSE_ROLES_DATA_SUCCESS } from '../CourseAdmin/actions';
import {
  SHOW_CREATE_NEW_CLASS_MODAL,
  FETCH_COURSE_CLASSES_SUCCESS,
  SAVE_COHORT_SUCCESS,
} from '../../web/containers/CourseAdmin/CourseClasses/actions';
import { CHECK_COURSE_ENROLMENT_ACCESS_CODE_SUCCESS } from '../Enrolments/actions';
import {
  FETCH_INSTITUTION_STUDENT_DATA_SUCCESS,
  FETCH_INSTITUTION_STUDENT_DATA_FAILURE,
} from '../InstitutionAdminUI/StudentData/actions';
// noinspection JSUnusedLocalSymbols
/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function Cohorts(state = Immutable.Map(), action = { type: null }) {
  switch (action.type) {
    case SET_ACTIVE_COHORT: {
      const cohort = Immutable.fromJS(action.cohort);
      const cohortPath = cohort.get('path').toLowerCase();
      return state.set(cohortPath, cohort);
    }
    case APPEND_BLOCK_FEED_DATA:
    case PREPEND_BLOCK_FEED_DATA:
    case SET_BLOCK_FEED_DATA:
    case SET_COURSE_LANDING_PAGE_DATA:
    case UPDATE_COHORTS:
    case UPDATE_ENROLLED_CLASS_DATA:
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case FEED_DATA_FETCH_SUCCESS:
    case FEED_DATA_REFRESH_SUCCESS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS:
    case FETCH_COURSE_ROLES_DATA_SUCCESS:
    case FETCH_COURSE_CLASSES_SUCCESS:
    case FEED_DATA_LOAD_MORE_SUCCESS:
    case BLOCK_FEED_DATA_LOAD_MORE_SUCCESS:
    case FETCH_ENROLLED_CLASS_DATA_SUCCESS: {
      let newState = state;
      action.cohortList.forEach(
        (cohort) =>
          (newState = newState.set(
            cohort.path.toLowerCase(),
            Immutable.fromJS(cohort)
          ))
      );
      return newState;
    }
    case COURSES_FETCH_SUCCESS:
    case COURSES_LOAD_SUCCESS:
    case COURSES_FREE_FETCH_SUCCESS:
    case COURSES_FREE_LOAD_SUCCESS:
    case COURSES_PAID_FETCH_SUCCESS:
    case COURSES_PAID_LOAD_SUCCESS:
    case COURSES_FEATURED_FETCH_SUCCESS:
    case COURSES_FEATURED_LOAD_SUCCESS: {
      let newState = state;
      _.forEach(action.cohortsData, (cohort) => {
        newState = newState.set(
          cohort.path.toLowerCase(),
          Immutable.fromJS(cohort)
        );
      });
      return newState;
    }
    case FETCH_INSTITUTION_STUDENT_DATA_SUCCESS:
    case FETCH_INSTITUTION_STUDENT_DATA_FAILURE: {
      const { cohorts } = action;
      return cohorts ? state.merge(cohorts) : state;
    }
    case SAVE_COHORT_SUCCESS: {
      const { cohortPath, cohort } = action;
      const newCohort = state.get(cohortPath).merge(Immutable.fromJS(cohort));

      return state.set(cohortPath, newCohort);
    }
    case SHOW_CREATE_NEW_CLASS_MODAL: {
      const defaultCohort = Immutable.fromJS(action.defaultCohort);
      return state.set(defaultCohort.get('path'), defaultCohort);
    }
    case COHORT_ADD_ASSESSMENT_PRESET: {
      const { cohortPath, preset } = action;
      return state.updateIn(
        [cohortPath, 'assessmentPresets'],
        (assessmentPresets) => assessmentPresets.push(Immutable.fromJS(preset))
      );
    }
    case COHORT_DELETE_ASSESSMENT_PRESET: {
      const { cohortPath, presetId } = action;
      return state.updateIn(
        [cohortPath, 'assessmentPresets'],
        (assessmentPresets) =>
          assessmentPresets.filter((preset) => preset.get('_id') !== presetId)
      );
    }
    case UPDATE_COHORT_ASSESSMENT_SETTINGS: {
      const { cohortPath, assessmentSettings } = action;
      return state.setIn(
        [cohortPath, 'assessmentSettings'],
        Immutable.fromJS(assessmentSettings)
      );
    }
    case UPDATE_COHORT_STARTDATE: {
      const { cohortPath, startDate } = action;
      return state.setIn([cohortPath, 'startDate'], startDate);
    }
    case UPDATE_COHORT_ENDDATE: {
      const { cohortPath, endDate } = action;
      return state.setIn([cohortPath, 'endDate'], endDate);
    }
    case SET_COHORT_SCHEDULED_MODE: {
      const { cohortPath } = action;
      return state.mergeIn([cohortPath], {
        isScheduled: true,
        isOpen: false,
      });
    }
    case SET_COHORT_OPEN_MODE: {
      const { cohortPath } = action;
      return state.mergeIn([cohortPath], {
        isScheduled: false,
        isOpen: true,
        isSelfPaced: false,
      });
    }
    case SET_COHORT_SELF_PACED_MODE: {
      const { cohortPath } = action;
      return state.mergeIn([cohortPath], {
        isScheduled: false,
        isOpen: false,
        isSelfPaced: true,
      });
    }
    case UPDATE_COHORT_SELF_PACED: {
      const { cohortPath, isSelfPaced } = action;
      return state.setIn([cohortPath, 'isSelfPaced'], isSelfPaced);
    }
    case CHECK_COURSE_ENROLMENT_ACCESS_CODE_SUCCESS: {
      const { cohort } = action;
      return state.mergeIn(
        [cohort.path.toLowerCase()],
        Immutable.fromJS(cohort)
      );
    }
    case UPDATE_COHORT_ENROLMENT_CLOSE_DATE: {
      const { cohortPath, enrolmentCloseDate } = action;
      return state.setIn(
        [cohortPath, 'enrolmentSettings', 'enrolmentCloseDate'],
        enrolmentCloseDate
      );
    }
    case LOGOUT_SUCCESS: {
      return Immutable.Map();
    }
    default:
      return state;
  }
}
